import { render, staticRenderFns } from "./daughterCardManage.vue?vue&type=template&id=ddac6766&scoped=true&"
import script from "./daughterCardManage.vue?vue&type=script&lang=js&"
export * from "./daughterCardManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddac6766",
  null
  
)

export default component.exports